import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";
import { c } from '../../theme/colorUtils';

// 캘린더 기본 스타일 상수
export const CALENDAR_TRANSITIONS = {
  smooth: '0.8s cubic-bezier(0.23, 1, 0.32, 1)',
  fast: '0.6s cubic-bezier(0.4, 0, 0.2, 1)',
  quick: '0.2s ease',
  collapse: 'opacity 0.3s ease, transform 0.6s cubic-bezier(0.23, 1, 0.32, 1), max-height 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0.1s',
  viewTransition: '0.6s cubic-bezier(0.23, 1, 0.32, 1)',
  fadeTransition: '0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
};

export const CALENDAR_SIZES = {
  weekView: 'auto',
  monthView: 'auto',
  tileSize: '40px',
  abbrSize: '36px'
};

// 캘린더 공통 스타일
export const calendarBaseStyles = {
  alignItems: 'center',
  transition: `min-height ${CALENDAR_TRANSITIONS.viewTransition}`,
  
  '& .react-calendar': {
    border: '0',
    padding: '8px',
    paddingBottom: '16px',
    transition: `height ${CALENDAR_TRANSITIONS.viewTransition}`,
    backgroundColor: 'transparent',
  },
  
  '& .react-calendar__month-view__weekdays, & .react-calendar__month-view__days': {
    padding: '0 8px',
    overflow: 'hidden',
    transition: `max-height ${CALENDAR_TRANSITIONS.viewTransition}`,
  },
};

// 네비게이션 스타일
export const navigationStyles = {
  '& .react-calendar__navigation': {
    marginBottom: '0.5rem',
    
    '& .react-calendar__navigation__label': {
      pointerEvents: 'none',
      cursor: 'default',
    },
    
    '& .react-calendar__navigation__label__labelText': {
      fontSize: '16px',
      fontWeight: '500',
      color: c.text01,
    },
    '& .week-navigation': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      
      '& .week-nav-button': {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '4px',
        borderRadius: '4px',
        color: c.hardest,
        transition: `all ${CALENDAR_TRANSITIONS.quick}`,
        
        '&:hover:not(:disabled)': {
          backgroundColor: c.lightest,
          color: c.text01,
        },
        '&:disabled': {
          opacity: 0.3,
          cursor: 'not-allowed',
        },
        '& svg': {
          fontSize: '1.25rem',
        }
      },
      
      '& .week-title': {
        fontSize: '0.875rem',
        fontWeight: '500',
        color: c.text01,
        minWidth: '120px',
        textAlign: 'center',
      }
    }
  },
  
  // 년/월 네비게이션 버튼 숨김
  '& .react-calendar__navigation__prev2-button, & .react-calendar__navigation__next2-button': {
    display: 'none',
  },
};

// 타일 스타일
export const tileStyles = {
  '& .react-calendar__tile, & .react-calendar__month-view__weekdays__weekday': {
    position: 'relative',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: CALENDAR_SIZES.tileSize,
    transition: `all ${CALENDAR_TRANSITIONS.viewTransition}`,
  },
  
  '& abbr': {
    width: CALENDAR_SIZES.abbrSize,
    height: CALENDAR_SIZES.abbrSize,
    margin: '2px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none'
  },
  
  // 활성 상태 스타일
  '& .react-calendar__tile:enabled:hover, & .react-calendar__tile:enabled:focus, & .react-calendar__tile--active, & .react-calendar__tile--hasActive': {
    background: 'transparent!important',
  },
  
  '& .react-calendar__tile--active:enabled:hover abbr, & .react-calendar__tile--active abbr, & .react-calendar__tile--hasActive abbr': {
    background: `${c.primary}!important`,
    borderRadius: '50%',
    color: '#333'
  },
};

// 오늘 날짜 스타일
export const todayStyles = {
  '& .react-calendar__tile--now': {
    background: 'none!important',
    color: c.text01,
    
    
    '& abbr': {
      border: `1px solid ${c.warning}`,
      borderRadius: '50%',
    },
    
    '&:hover, &:focus': {
      background: 'none',
    },
    
    '&.react-calendar__tile--active abbr': {
      background: `${c.primary}!important`,
      borderRadius: '50%',
    },
    
    '&:not(.react-calendar__tile--active)': {
      justifyContent: 'center',
      
      '&.act': {
        alignItems: 'flex-end',
        '& abbr': {
          height: '15px',
          background: 'orange',
          borderRadius: '100px',
          color: '#fff',
          zIndex: 1
        }
      },
    },
  },
};

// 특별한 날짜 스타일 (활동이 있는 날)
export const activityStyles = {
  '& .react-calendar__tile.act': {
    alignItems: 'flex-end',
    '& abbr': {
      height: '15px',
      background: 'orange',
      borderRadius: '100px',
      color: '#fff',
      zIndex: 1
    },
  },
};

// 주말 및 기타 스타일
export const miscStyles = {
  // 토요일은 파란색
  '& .react-calendar__tile--saturday': {
    color: '#1976d2!important',
  },
  // 일요일은 빨간색 (기존 유지)
  '& .react-calendar__tile--sunday': {
    color: `${c.error}!important`,
  },
  
  '& .react-calendar__month-view__days__day, & .react-calendar__navigation__arrow': {
    color: c.text01,
  },
  
  '& .react-calendar__navigation__arrow': {
    fontSize: 24
  },
  
  '& .react-calendar__decade-view__years__year, & .react-calendar__century-view__decades__decade': {
    padding: '16px 0!important'
  },
};

// 뷰모드별 스타일
export const viewModeStyles = {
  // 홈 화면 스타일
  '&.home': {
    '& .pokoro-icon': {
      position: 'absolute',
      top: 0,
    },
  },
  
  // 전환 중 스타일
  '&.transitioning': {
    '& .react-calendar': {
      opacity: 0.7,
      transform: 'scale(0.98)',
      transition: `opacity 0.3s ease-out, transform 0.3s ease-out`,
    },
    
    '& .react-calendar__month-view__days': {
      transition: `all ${CALENDAR_TRANSITIONS.viewTransition}`,
      opacity: 0.5,
    },
    
    '& .react-calendar__tile': {
      transition: `all ${CALENDAR_TRANSITIONS.viewTransition}`,
      transform: 'scale(0.95)',
    },
  },
  
  // 주간 보기 스타일
  '&.week-view': {
    minHeight: CALENDAR_SIZES.weekView,
    transition: `min-height ${CALENDAR_TRANSITIONS.viewTransition}`,
    
    '& .react-calendar': {
      width: '100%',
      transition: `height ${CALENDAR_TRANSITIONS.viewTransition}, opacity 0.3s ease-in, transform 0.3s ease-in`,
      opacity: 1,
      transform: 'scale(1)',
    },
    
    '& .react-calendar__month-view__days': {
      transition: `max-height ${CALENDAR_TRANSITIONS.viewTransition}, opacity ${CALENDAR_TRANSITIONS.fadeTransition}`,
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)',
      gap: 0,
    },
    
    '& .react-calendar__tile.week-hidden': {
      maxHeight: 0,
      overflow: 'hidden',
      opacity: 0,
      transform: 'scaleY(0)',
      transition: CALENDAR_TRANSITIONS.collapse,
      transformOrigin: 'center top',
      padding: 0,
      margin: 0,
      border: 'none',
      pointerEvents: 'none',
    },
    
    '& .react-calendar__tile:not(.week-hidden)': {
      transition: `all ${CALENDAR_TRANSITIONS.viewTransition}`,
      opacity: 1,
      transform: 'scaleY(1)',
      maxHeight: CALENDAR_SIZES.tileSize,
    },
  },
  
  // 월간 보기 스타일
  '&:not(.week-view)': {
    minHeight: CALENDAR_SIZES.monthView,
    transition: `min-height ${CALENDAR_TRANSITIONS.viewTransition}`,
    
    '& .react-calendar': {
      width: '100%',
      transition: `height ${CALENDAR_TRANSITIONS.viewTransition}, opacity ${CALENDAR_TRANSITIONS.fadeTransition}, transform ${CALENDAR_TRANSITIONS.fadeTransition}`,
      opacity: 1,
      transform: 'scale(1)',
    },
    
    '& .react-calendar__month-view__days': {
      transition: `max-height ${CALENDAR_TRANSITIONS.viewTransition}, opacity ${CALENDAR_TRANSITIONS.fadeTransition}`,
      opacity: 1,
    },
    
    '& .react-calendar__tile': {
      transition: `all ${CALENDAR_TRANSITIONS.viewTransition}`,
      opacity: 1,
      transform: 'scaleY(1)',
      maxHeight: CALENDAR_SIZES.tileSize,
    },
    
  },
  
  // 데이터 모달 스타일
  '&.data': {
    position: 'fixed',
    zIndex: 110,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '500px',
  },
};

// 메인 캘린더 컴포넌트
export const CalendarBox = styled(Stack)(() => ({
  borderRadius: '24px',
  backgroundColor: c.bg,
  ...calendarBaseStyles,
  ...navigationStyles,
  ...tileStyles,
  ...todayStyles,
  ...activityStyles,
  ...miscStyles,
  ...viewModeStyles,
  
}));
